const SubscriptionType = {
  B2C_HOSTING_FREE: 'free',
  B2C_HOSTING_BRONZE: 'bronze',
  B2C_HOSTING_SILVER: 'silver',
  B2C_HOSTING_GOLD: 'gold',

  WL_HOSTING_FREE: 'wl_free',
  WL_HOSTING_MINI: 'wl_mini',
  WL_HOSTING_ULTRA_LITE: 'wl_ultra_lite',
  WL_HOSTING_LITE: 'wl_lite',
  WL_HOSTING_BASIC: 'wl_basic',
  WL_HOSTING_PREMIUM: 'wl_premium',
  WL_PREMIUM_ECOMM: 'wl_premium_ecomm',

  B2C_ECOMMERCE_FREE: 'ecommerce_free',
  B2C_ECOMMERCE_BASIC: 'ecommerce_basic',
  B2C_ECOMMERCE: 'ecommerce',
  B2C_ECOMMERCE_PROFESSIONAL: 'ecommerce_professional',
  B2C_ECOMMERCE_UNLIMITED: 'ecommerce_unlimited',

  WL_ECOMMERCE_FREE: 'wl_ecommerce_free',
  WL_ECOMMERCE_BASIC: 'wl_ecommerce_basic',
  WL_ECOMMERCE_LEGACY: 'wl_ecommerce_legacy',
  WL_ECOMMERCE_PROFESSIONAL: 'wl_ecommerce_professional',
  WL_ECOMMERCE_UNLIMITED: 'wl_ecommerce_unlimited',

  DOMAIN_SUBSCRIPTION: 'domain',

  ADVERTISING_SEARCH_EMERGING: 'wl_advertising_search_emerging',
  ADVERTISING_SEARCH_STARTER: 'wl_advertising_search_starter',
  ADVERTISING_SEARCH_GROWTH: 'wl_advertising_search_growth',
  ADVERTISING_SEARCH_NURTURE: 'wl_advertising_search_nurture',
  ADVERTISING_SEARCH_PRO: 'wl_advertising_search_pro',
  ADVERTISING_SEARCH_ENTERPRISE: 'wl_advertising_search_enterprise',
  ADVERTISING_DISPLAY_STARTER: 'wl_advertising_display_starter',
  ADVERTISING_DISPLAY_GROWTH: 'wl_advertising_display_growth',
  ADVERTISING_DISPLAY_NURTURE: 'wl_advertising_display_nurture',
  ADVERTISING_DISPLAY_PRO: 'wl_advertising_display_pro',
} as const;

export default SubscriptionType;

export const B2C_HOSTING_TYPES = [
  SubscriptionType.B2C_HOSTING_FREE,
  SubscriptionType.B2C_HOSTING_BRONZE,
  SubscriptionType.B2C_HOSTING_SILVER,
  SubscriptionType.B2C_HOSTING_GOLD,
];

export const B2C_HOSTING_PAID_TYPES = [
  SubscriptionType.B2C_HOSTING_BRONZE,
  SubscriptionType.B2C_HOSTING_SILVER,
  SubscriptionType.B2C_HOSTING_GOLD,
];

export const WL_HOSTING_TYPES = [
  SubscriptionType.WL_HOSTING_FREE,
  SubscriptionType.WL_HOSTING_MINI,
  SubscriptionType.WL_HOSTING_ULTRA_LITE,
  SubscriptionType.WL_HOSTING_LITE,
  SubscriptionType.WL_HOSTING_BASIC,
  SubscriptionType.WL_HOSTING_PREMIUM,
];

export const WL_HOSTING_PAID_TYPES = [
  SubscriptionType.WL_HOSTING_ULTRA_LITE,
  SubscriptionType.WL_HOSTING_LITE,
  SubscriptionType.WL_HOSTING_BASIC,
  SubscriptionType.WL_HOSTING_PREMIUM,
];

export const B2C_ECOMMERCE_TYPES = [
  SubscriptionType.B2C_ECOMMERCE_FREE,
  SubscriptionType.B2C_ECOMMERCE_BASIC,
  SubscriptionType.B2C_ECOMMERCE,
  SubscriptionType.B2C_ECOMMERCE_PROFESSIONAL,
  SubscriptionType.B2C_ECOMMERCE_UNLIMITED,
];

export const B2C_ECOMMERCE_PAID_TYPES = [
  SubscriptionType.B2C_ECOMMERCE_BASIC,
  SubscriptionType.B2C_ECOMMERCE,
  SubscriptionType.B2C_ECOMMERCE_PROFESSIONAL,
  SubscriptionType.B2C_ECOMMERCE_UNLIMITED,
];

export const WL_ECOMMERCE_TYPES = [
  SubscriptionType.WL_ECOMMERCE_FREE,
  SubscriptionType.WL_ECOMMERCE_BASIC,
  SubscriptionType.WL_ECOMMERCE_LEGACY,
  SubscriptionType.WL_ECOMMERCE_PROFESSIONAL,
  SubscriptionType.WL_ECOMMERCE_UNLIMITED,
  SubscriptionType.WL_PREMIUM_ECOMM,
];

export const WL_ECOMMERCE_PAID_TYPES = [
  SubscriptionType.WL_ECOMMERCE_BASIC,
  SubscriptionType.WL_ECOMMERCE_LEGACY,
  SubscriptionType.WL_ECOMMERCE_PROFESSIONAL,
  SubscriptionType.WL_ECOMMERCE_UNLIMITED,
  SubscriptionType.WL_PREMIUM_ECOMM,
];

export const MOST_POPULAR_ECOMMERCE_PLANS = [
  SubscriptionType.B2C_ECOMMERCE_PROFESSIONAL,
  SubscriptionType.WL_ECOMMERCE_PROFESSIONAL,
];

export const NON_PURCHASABLE_ECOMMERCE_PLANS = [
  SubscriptionType.WL_ECOMMERCE_LEGACY,
  SubscriptionType.B2C_ECOMMERCE,
];

export const HOSTING_PAID_TYPES = [...B2C_HOSTING_PAID_TYPES, ...WL_HOSTING_PAID_TYPES];

export const ECOMMERCE_PAID_TYPES = [...B2C_ECOMMERCE_PAID_TYPES, WL_ECOMMERCE_PAID_TYPES];

export const ADVERTISING_TYPES = [
  SubscriptionType.ADVERTISING_SEARCH_EMERGING,
  SubscriptionType.ADVERTISING_SEARCH_STARTER,
  SubscriptionType.ADVERTISING_SEARCH_GROWTH,
  SubscriptionType.ADVERTISING_SEARCH_NURTURE,
  SubscriptionType.ADVERTISING_SEARCH_PRO,
  SubscriptionType.ADVERTISING_SEARCH_ENTERPRISE,
  SubscriptionType.ADVERTISING_DISPLAY_STARTER,
  SubscriptionType.ADVERTISING_DISPLAY_GROWTH,
  SubscriptionType.ADVERTISING_DISPLAY_NURTURE,
  SubscriptionType.ADVERTISING_DISPLAY_PRO,
];
